import BaseNode from './BaseNode';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { colors } from '../../styles';

const DefaultNode = ({ data }: { data: { label: string } }) => (
  <BaseNode label={data.label} typeLabel="Bloco" accent={colors.brand.textMuted} icon={<RadioButtonUncheckedIcon />} />
);

export default DefaultNode;
